export default __webpack_public_path__ + "static/media/27.e0d28b9e.svg";